import { hasHtmlTags, stripHtmlTags } from './translateString'

export const isSelectedDescription = (text: string, selectedDescription: string[]): boolean => {
  const hasHtmlTag = hasHtmlTags(text)
  return selectedDescription.includes(hasHtmlTag ? stripHtmlTags(text) : text)
}
